/**
 * Sesión vencida — pub/sub con el mismo patrón que `inbox-events.ts`.
 *
 * Quien descubre que la sesión de persona ya no sirve (el interceptor de apiClient cuando falla el
 * /auth/refresh, o el canje de Activa cuando responde 401, 403 SIN_ACCESO o 404) no tiene a mano el
 * AuthContext: avisa con este evento, y AuthContext cierra la sesión. Con `user` en null,
 * ProtectedRoute lleva a /login y guarda adónde se quería ir.
 */

export const SESION_VENCIDA_EVENT = "deenex:sesion-vencida";

/** Avisar que la sesión de persona venció o que a la persona le quitaron el acceso. */
export function avisarSesionVencida(): void {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(SESION_VENCIDA_EVENT));
}

/** Suscribirse al aviso. Devuelve la función para desuscribirse. */
export function alVencerSesion(handler: () => void): () => void {
    if (typeof window === "undefined") return () => {};
    window.addEventListener(SESION_VENCIDA_EVENT, handler);
    return () => window.removeEventListener(SESION_VENCIDA_EVENT, handler);
}
